module.exports = __webpack_public_path__ + "media/images/icon__minus-b1bd845859dd925623fce04464e7d3cd.png";